<template>
  <div>
    <FieldInput
      v-bind="attrBind"
      append-icon="mdi-upload"
      clearable
      readonly
      :value="currentShowValue"
      v-on="$listeners"
      @click="upload"
      @click:append="upload"
      @click:clear="clear"
    ></FieldInput>
    <input
      ref="file"
      :accept="accept"
      hidden
      name="files"
      type="file"
      @change="changeFile"
    />
  </div>
</template>

<script>
import FieldMixin from './field-mixin'
import FieldInput from './field-input.vue'
export default {
  inheritAttrs: false,
  components: { FieldInput },
  mixins: [FieldMixin],
  props: { value: {}, accept: String },
  data: () => ({ file: null }),
  computed: {
    currentShowValue: {
      get() {
        if (typeof this.value == 'string') return this.value
        if (this.file) return this.file.name
        return ''
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    clear() {
      this.$emit('change', [])
    },
    upload() {
      this.$refs.file.click()
    },
    changeFile(e) {
      const input = this.$refs.file
      let files = e.target.files
      this.file = files[0]
      this.$emit('change', this.file)
      this.currentShowValue = files[0]
      input.type = 'text'
      input.type = 'file'
    },
  },
}
</script>

<style scoped></style>
